<template>
  <customFieldsAddingPreview
    :icon='"dropdown.svg"'
    :name="preloadedItem.name || 'Dropdown'">

    <template :slot='"body"'>
      <div class="input-mb input-box d-flex flex-nowrap">
        <v-select
          :items="arrayValues"
          :placeholder="preloadedItem.placeholder"
          v-model='value'
          class="r-field general-settings-select"/>
      </div>
    </template>
  </customFieldsAddingPreview>
</template>

<script>
import customFieldsAddingPreview from '../customFieldsAddingPreview'
export default {
  props: {
    preloadedItem: {
      type: Object,
      default: () => {
        return {
          name: '',
          placeholder: '',
          defaultValue: null,
          customFieldArrayValues: []
        }
      }
    }
  },
  watch: {
    'preloadedItem.customFieldArrayValues': {
      handler (arrayValues) {
        this.value = this.getDefaultArrayValue()
      },
      deep: true
    }
  },
  computed: {
    arrayValues() {
      return this.preloadedItem.customFieldArrayValues.map(cfav => cfav.value)
    }
  },
  methods: {
    getDefaultArrayValue() {
      const defaultArrayValue = this.preloadedItem.customFieldArrayValues.find(cfav => cfav.isAsDefault)
      return defaultArrayValue?.value
    }
  },
  data: function() {
    return {
      value: this.getDefaultArrayValue()
    }
  },
  components: {
    customFieldsAddingPreview
  }
}
</script>
